import React, { useCallback } from 'react';
import styled from 'styled-components';
import "@fontsource/ibm-plex-mono";

const CategoryHeaderContainer = styled.div`
  height: 48px;
  width: 100%;
  margin-bottom: 40px;
  
  @media (min-width: 768px) {
    padding-left: 100px;
  }
`;

const CategoryHead = styled.header`
  height: 48px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
`;

const CategoryTitleSection = styled.div`
  display: flex;
  align-items: center;
  height: 44px;
  max-width: 754px;
`;

const CategoryTitle = styled.h1`
  color: #a13b16;
  font-family: "IBM Plex Mono", monospace;
  font-size: 24px;
  font-weight: 700;
  margin: 0;
  margin-left: 20px;
  letter-spacing: 0;
  line-height: normal;
  max-width: 697px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;

  &:first-word {
    color: yellow !important;
  }
`;

const BookIcon = styled.img`
  height: 32px;
  width: 28px;
  flex-shrink: 0;
`;


interface CategoryHeaderProps {
  title?: string;
}

const CategoryHeader: React.FC<CategoryHeaderProps> = React.memo(({title = "Приклад пошукового запиту:"}) => {
  return (
    <CategoryHeaderContainer>
      <CategoryHead>
        <CategoryTitleSection>
          <BookIcon src={`/media/BookIcon.svg`} alt="Book icon" />
          <CategoryTitle>{title}</CategoryTitle>
        </CategoryTitleSection>
      </CategoryHead>
    </CategoryHeaderContainer>
  );
});

CategoryHeader.displayName = 'CategoryHeader';

export default CategoryHeader;